var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"z-50 inset-0 fixed bg-black opacity-50 flex items-center justify-center lg:ml-38 xl:ml-26 h-screen md:ml-0 md:min-h-screen"},[_c('Lynx-Spinner',{attrs:{"size":"14"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }